// src/constants/index.ts
var APP_NAME = "sim-store";
var API_PREFIX = "/api";
var HEALTH_ROUTE = `${API_PREFIX}/health`;
var DEFAULT_PAGE_SIZE = 20;
var MAX_PAGE_SIZE = 100;
var QUEUE_PREFIX = "sim-store";
var ACCESS_TOKEN_KEY = "access_token";
var REFRESH_TOKEN_KEY = "refresh_token";
var ACCESS_TOKEN_COOKIE = "access_token_cookie";
var REFRESH_TOKEN_COOKIE = "refresh_token_cookie";
var SYNC_EVENT_CHANNEL = `${QUEUE_PREFIX}:sync-events`;
var JACKPOT_EVENT_CHANNEL = `${QUEUE_PREFIX}:jackpot-events`;
export {
  ACCESS_TOKEN_COOKIE,
  ACCESS_TOKEN_KEY,
  API_PREFIX,
  APP_NAME,
  DEFAULT_PAGE_SIZE,
  HEALTH_ROUTE,
  JACKPOT_EVENT_CHANNEL,
  MAX_PAGE_SIZE,
  QUEUE_PREFIX,
  REFRESH_TOKEN_COOKIE,
  REFRESH_TOKEN_KEY,
  SYNC_EVENT_CHANNEL
};
//# sourceMappingURL=index.js.map